import React from 'react'
import { formatDate } from '@@partner:helpers/util'

import { Tag } from 'rsuite'
import { CustomerPromocodes } from '@@partner:types:app'

export interface PromocodeSaleInfoProps {
  saleInfo: CustomerPromocodes
}

export default function PromocodeSaleInfo ({
  saleInfo
}: PromocodeSaleInfoProps) {
  return (
    <div className="ViewCustomer__Info__Row">
      <strong>Применён промокод:</strong> {saleInfo.code}{' '}
      <Tag color="blue">{formatDate(new Date(saleInfo.usedAt))}</Tag>
    </div>
  )
}
